import { useCallback } from 'react';
import ContentLoader from 'react-content-loader';
import { MdOutlineSimCardDownload } from "react-icons/md";
import CurrencyFormat from 'react-number-format';
import Tooltip from 'react-tooltip-lite';
import {
    Button,
    Card,
    CardBody,
    Col,
    Progress,
    Row,
} from 'reactstrap';
import { useProfileQuery } from 'src/modules/myProfile/src/profileQueries';
import NoRecordLogo from '../../../assets/logo/No_record_logo.png';
import Paginate from '../../../components/Paginate';
import { useFundDispatch } from '../../../contexts/FundContext';
import { useInvestmentNoteDispatch } from '../../../contexts/InvestmentNoteContext';
import { useKnowledgeTestState } from '../../../contexts/KnowledgeTestContext';
import { useDict } from '../../../contexts/LanguageContext';
import useWindowSize from '../../../hooks/useWindowSize';
import {
    BootstrapBreakpoints,
    InvestmentNoteLaunchStatus
} from '../../../utils/constants';
import { dateFormatter } from '../../../utils/dateHelper';
import { getDownloadInvestmentMemo } from '../../investmentNote/src/investmentNoteApis';
// import { useCommentModalContext } from '../../../contexts/CommentModalContext';

const AvailableInvestmentNoteList = (props) => {
    const {
        investmentNotes,
        isFetching,
        handleViewInvestmentNote,
        handleInvest,
        page,
        setPage,
        pageCount,
    } = props;

    const dict = useDict();
    const language = localStorage.getItem('language') === 'en' ? 'en' : 'th';

    const { data: profileData } = useProfileQuery();

    const investmentNoteDispatch = useInvestmentNoteDispatch();
    const fundDispatch = useFundDispatch();
    const knowledgeTestState = useKnowledgeTestState();

    const { width } = useWindowSize();
    const isMobile = width <= BootstrapBreakpoints.SM;

    // const { openCommentModal } = useCommentModalContext();

    const onPageChange = useCallback((event) => {
        setPage(event.selected + 1);
    }, []);

    // const handleOpenCommentModal = (data) =>
    //     openCommentModal({
    //         commentData: data.comments,
    //     });

    const onDownloadInvestmentMemo = (investmentNoteId) => {
        const payload = {
            investment_note_id: investmentNoteId
        };

        getDownloadInvestmentMemo(payload);
    }

    const renderList = () => {
        if (isFetching) {
            return [...Array(3)].map((_, index) => (
                <ContentLoader
                    width="100%"
                    height="220"
                    gradientDirection="top-bottom"
                    backgroundColor="#eee"
                    foregroundOpacity={0.3}
                    className="mb-4"
                    key={`content-loader-${index}`}
                >
                    <rect width="100%" height="100%" y="0" rx="10" ry="10" />
                </ContentLoader>
            ));
        }

        if (investmentNotes && investmentNotes.length > 0 && profileData?.is_kyc_verified) {
            return (
                <>
                    {investmentNotes.map((data) => (
                        <Card
                            style={{ marginBottom: 20 }}
                            key={data.id}
                        >
                            <CardBody style={{ padding: 20 }}>
                                <Row className="align-items-center mb-2 g-0">
                                    <h4
                                        onClick={() =>
                                            // handleViewInvestmentNote(data)
                                            investmentNoteDispatch({ type: 'viewInvestmentNoteDetails', investmentNote: data })
                                        }
                                        className='invest-now-title'
                                        aria-hidden
                                    >
                                        <u>{data.name}</u>
                                    </h4>

                                    {
                                        data.has_investment_memo && (
                                            <div
                                                className='icon-wrapper ml-2'
                                                onClick={() => onDownloadInvestmentMemo(data.id)}
                                            >
                                                <MdOutlineSimCardDownload size={24} color='#f29525' />
                                            </div>
                                        )
                                    }

                                    {/* <div
                                        style={{
                                            width: '10%',
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                        }}
                                    >
                                        <Icon
                                            icon={
                                                data.isOptIn === '1'
                                                    ? 'CheckCircleSolid'
                                                    : 'TimesCircle'
                                            }
                                            width="20"
                                            style={{
                                                color:
                                                    data.isOptIn === '1'
                                                        ? '#4ce1b6'
                                                        : '#ff4861',
                                            }}
                                        />
                                        {data.comments.length > 0 && (
                                            <span
                                                onClick={() =>
                                                    handleOpenCommentModal(data)
                                                }
                                                aria-hidden
                                                role="button"
                                                tabIndex={0}
                                                style={{
                                                    width: '24px',
                                                }}
                                            >
                                                <img
                                                    src={Announcement}
                                                    alt="announcement"
                                                />
                                            </span>
                                        )}
                                    </div> */}
                                </Row>
                                {/* <Row
                                    className="mb-2 g-0"
                                    style={{ rowGap: '4px', width: 'fit-content' }}
                                >
                                    <div
                                        key={data.theme.id}
                                        className="invest-now-badge"
                                    >
                                        {data.theme[appendLocale('name')]}
                                    </div>
                                </Row>
                                <Row className="mb-1 g-0">
                                    <h5 className="color-grey shortLongText2">
                                        {data.description}
                                    </h5>
                                </Row> */}
                                <Row style={{ paddingTop: 10 }}>
                                    <Col md={6} sm={12}>
                                        <div className="d-flex justify-content-between">
                                            <Col
                                                xs={6}
                                                className="text-return bold-text"
                                            >
                                                {dict.netReturn}
                                            </Col>
                                            <Col
                                                xs={6}
                                                className="text-return text-right"
                                            >
                                                {parseFloat(
                                                    data.net_return_rate
                                                ).toFixed(1)}{' '}
                                                %{' '}
                                                {dict.pa}
                                            </Col>
                                        </div>
                                    </Col>

                                    {data.issuer_name && (
                                        <Col md={6} sm={12}>
                                            <Row>
                                                <Col
                                                    xs={4}
                                                    className="bold-text"
                                                >
                                                    {dict.issuer}
                                                </Col>
                                                <Col
                                                    xs={8}
                                                    className="text-right"
                                                >
                                                    {data.issuer_name}
                                                </Col>
                                            </Row>
                                        </Col>
                                    )}

                                    <Col md={6} sm={12}>
                                        <Row>
                                            <Col xs={6} className="bold-text">
                                                {dict.expectedTenure}
                                            </Col>
                                            <Col xs={6} className="text-right">
                                                {data.tenure_days} {dict.days}
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col md={6} sm={12}>
                                        <Row>
                                            <Col xs={6} className="bold-text">
                                                {dict.expectedMaturityDate}
                                            </Col>
                                            <Col xs={6} className="text-right">
                                                {dateFormatter(data.maturity_date, language)}
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col md={6} sm={12}>
                                        <div className="d-flex justify-content-between">
                                            <Col xs={6} className="bold-text">
                                                {dict.financingAmount}
                                            </Col>
                                            <Col xs={6} className="text-right">
                                                <CurrencyFormat
                                                    value={parseFloat(
                                                        data.amount
                                                    ).toFixed(2)}
                                                    displayType="text"
                                                    thousandSeparator
                                                    prefix="฿ "
                                                />
                                            </Col>
                                        </div>
                                    </Col>

                                    {data.invest_amount > 0 && (
                                        <Col md={6} sm={12}>
                                            <Row>
                                                <Col xs={6} className="bold-text">
                                                    {dict.committedAmount}
                                                </Col>
                                                <Col xs={6} className="text-right">
                                                    <CurrencyFormat
                                                        value={parseFloat(
                                                            data.invest_amount
                                                        ).toFixed(2)}
                                                        displayType="text"
                                                        thousandSeparator
                                                        prefix="฿ "
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    )}

                                    {/* {!data.firstTime && (
                                            <Row>
                                                <Col
                                                    xs={6}
                                                    className="bold-text"
                                                >
                                                    {data.allocationPhaseStatus !==
                                                    'invested'
                                                        ? 'Committed '
                                                        : data.allocationPhaseStatus}{' '}
                                                    Amount
                                                </Col>
                                                <Col
                                                    xs={6}
                                                    className="text-right"
                                                >
                                                    <CurrencyFormat
                                                        value={parseFloat(
                                                            data.individualAllocatedAmount
                                                        ).toFixed(2)}
                                                        displayType="text"
                                                        thousandSeparator
                                                        prefix="฿ "
                                                    />
                                                </Col>
                                            </Row>
                                        )} */}
                                </Row>
                                {/* <div
                                    className="progress-wrap--gradient-green-blue
                                        progress-wrap--middle progress-show-mobile"
                                    style={{ display: 'none' }}
                                >
                                    <Progress
                                        value={specialRound(
                                            (parseFloat(data.allocatedAmount) /
                                                parseFloat(data.issueAmount)) *
                                                100
                                        )}
                                    >
                                        {specialRound(
                                            (parseFloat(data.allocatedAmount) /
                                                parseFloat(data.issueAmount)) *
                                                100
                                        )}
                                        % Funded
                                    </Progress>
                                </div> */}
                                <Row
                                    style={{ paddingTop: 20 }}
                                    className="justify-content-center g-0"
                                >
                                    {(data.investment_note_status_id != InvestmentNoteLaunchStatus.PendingAllocation) ?
                                        (<div
                                            style={{ fontSize: '11px' }}
                                            className="launch mb-3"
                                        >
                                            <p className="launch-text">
                                                {dict.launchDateText}
                                            </p>
                                            <p
                                                className="launch_date m-0 text-center"
                                                style={{
                                                    fontSize: '16px',
                                                    color: '#2350F5',
                                                }}
                                            >
                                                {data.launch_date == null
                                                    ? 'N/A'
                                                    : dateFormatter(data.launch_date, language)
                                                }
                                            </p>{' '}
                                        </div>) : !knowledgeTestState.isPassedKnowledgeTest ?
                                            (
                                                <Tooltip
                                                    content={dict.completeKnowledgeTest}
                                                    styles={{ display: 'inline', width: 'fit-content' }}
                                                    distance={5}
                                                    arrowSize={8}
                                                >
                                                    <Button
                                                        color="#ffffff"
                                                        className="btn-outline-primary btn_uni2 rounded mb-3 d-sm-flex justify-content-center align-items-center mr-1 w-auto"
                                                        onClick={() =>
                                                            fundDispatch({ type: 'openInvestModal', investmentNote: data })
                                                        }
                                                        data-cy="topbar__button--withdraw"
                                                        disabled
                                                    >
                                                        {data.invest_amount > 0 ? dict.investMore : dict.invest}
                                                    </Button>
                                                </Tooltip>
                                            ) : (
                                                <Button
                                                    color="#ffffff"
                                                    className="btn-outline-primary btn_uni2 rounded mb-3 d-sm-flex justify-content-center align-items-center mr-1 w-auto"
                                                    onClick={() =>
                                                        fundDispatch({ type: 'openInvestModal', investmentNote: data })
                                                    }
                                                    data-cy="topbar__button--withdraw"
                                                    disabled={data.allocation_percentage >= 100}
                                                >
                                                    {data.invest_amount > 0 ? dict.investMore : dict.invest}
                                                </Button>
                                            )
                                    }
                                    {data.invest_amount > 0 && (
                                        <Button
                                            color="#ffffff"
                                            className="btn-outline-primary btn_uni2 rounded mb-3 d-sm-flex justify-content-center align-items-center mr-1 w-auto"
                                            onClick={() =>
                                                fundDispatch({ type: 'openWithdrawModal', investmentNote: data })
                                            }
                                            data-cy="topbar__button--withdraw"
                                            disabled={data?.is_withdraw_disabled}
                                        >
                                            {dict.withdraw}
                                        </Button>
                                    )}
                                </Row >
                                <div
                                    className="progress-wrap--gradient-green-blue
                                progress-wrap--middle progress-show"
                                >
                                    <Progress
                                        animated
                                        value={data.allocation_percentage}
                                    >
                                        {data.allocation_percentage}
                                        % {dict.funded}
                                    </Progress>
                                </div>
                            </CardBody >
                        </Card >
                    ))}
                    <Paginate
                        pageCount={pageCount}
                        onPageChange={onPageChange}
                        forcePage={page - 1}
                    />
                </>
            );
        }
        return (
            <div className="d-flex flex-column align-items-center mt-5 mb-4">
                <img
                    src={NoRecordLogo}
                    alt="noRecord"
                    style={{
                        width: isMobile ? '60%' : '30%',
                        objectFit: 'contain',
                        minHeight: isMobile ? '20vh' : undefined,
                    }}
                />
                <p className="text-align-center mt-3 font-size-18">{dict.noRecordNewOpportunity}</p>
            </div>
        );
    };

    return (
        <>
            {renderList()}
        </>
    );
};

export default AvailableInvestmentNoteList;
